module.exports = __webpack_public_path__ + "static/media/usermenu-profile.0e953b1e.jpg";